export interface ColorHelpers {
    raw: string;   // ex: 'teal'
    bg: string;   // 'bg-teal-600'
    bgHov: string;   // 'hover:bg-teal-700'
    text: string;   // 'text-teal-600'
    ring: string;   // 'focus:ring-teal-500'
    border: string;   // 'border-teal-500'
    light: string;   // 'bg-teal-50'
    light100: string; // 'bg-teal-100'
}

export function colorHelpers(color: string): ColorHelpers {
    return {
        raw: color,
        bg: `bg-${color}-600`,
        bgHov: `hover:bg-${color}-700`,
        text: `text-${color}-600`,
        ring: `focus:ring-${color}-500`,
        border: `border-${color}-500`,
        light: `bg-${color}-50`,
        light100: `bg-${color}-100`,
    };
}